import { render } from "./Com_Searchbar.vue?vue&type=template&id=7245ab4c&scoped=true"
import script from "./Com_Searchbar.vue?vue&type=script&lang=js"
export * from "./Com_Searchbar.vue?vue&type=script&lang=js"

import "./Com_Searchbar.vue?vue&type=style&index=0&id=7245ab4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7245ab4c"]])

export default __exports__